(function () {
  var FOOTER_SELECTOR = 'footer[id^="footer-"]';

  /* Newsletter email field grows with what's typed. The `size` attribute is
     measured in characters against the field's own font, so it tracks the
     merchant's chosen font size without any measurement work. */
  function init(root) {
    if (!root || root.dataset.footerInit === 'true') return;
    var input = root.querySelector('[data-autosize-email]');
    if (!input) return;
    root.dataset.footerInit = 'true';

    var controller = new AbortController();
    root.footerController = controller;

    var minChars = parseInt(input.dataset.minChars, 10) || 12;
    var placeholderChars = (input.getAttribute('placeholder') || '').length;

    function resize() {
      var chars = input.value.length || placeholderChars;
      input.size = Math.max(minChars, chars + 1);
    }
    resize();

    input.addEventListener('input', resize, { signal: controller.signal });
  }

  function teardown(root) {
    if (!root) return;
    if (root.footerController) {
      root.footerController.abort();
      delete root.footerController;
    }
    root.removeAttribute('data-footer-init');
  }

  document.querySelectorAll(FOOTER_SELECTOR).forEach(init);

  if (!window.__footerWired) {
    window.__footerWired = true;
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector(FOOTER_SELECTOR);
      if (root) init(root);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector(FOOTER_SELECTOR);
      if (root) teardown(root);
    });

    /* Country selector (snippets/country-selector.liquid) — close any open
       list on a click outside it or on Escape. Delegated on document, so it
       survives theme-editor section reloads without re-binding. */
    function closeCountrySelectors(except) {
      document.querySelectorAll('details[data-country-selector][open]').forEach(function (el) {
        if (el !== except) el.removeAttribute('open');
      });
    }
    document.addEventListener('click', function (e) {
      closeCountrySelectors(e.target.closest('details[data-country-selector]'));
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('details[data-country-selector][open]');
      if (!open) return;
      closeCountrySelectors(null);
      open.querySelector('summary').focus();
    });
  }
})();
